define('bindingHandlers/lTooltip',['lib/knockout'], function (ko) {
    'use strict';


    var getTooltipData = function (valueAccessor, viewModel) {
        var stringKey, data, locale,placement, selfDismiss, onlyIf,
            templateInfo = ko.unwrap(valueAccessor());

        if (typeof templateInfo == 'string') {
            stringKey = templateInfo;
            data = viewModel;
        } else if (templateInfo) {
            stringKey = templateInfo.name;
            data = templateInfo.data || viewModel;
            locale = templateInfo.locale;
            placement = templateInfo.placement;
            selfDismiss = templateInfo.selfDismiss;
            onlyIf = templateInfo.onlyIf;
        }

        var text = ko.i18n.renderString(stringKey,data,locale);

        valueAccessor = function(){
            return {'data':data,
                'text':text,
                'placement':placement,
                'selfDismiss':selfDismiss,
                'onlyIf':onlyIf
            };
        };

        return valueAccessor;
    };


    /**
     * Binding handler that delegates to tooltip binding handler.
     * Sample usage:
     *  data-bind = "lTooltip: {name:'activeCall.requestingHold', placement:'bottom,right', selfDismiss: false}"
     *  placement and selfDismiss are optional.
     */
    ko.bindingHandlers.lTooltip = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            valueAccessor = getTooltipData(valueAccessor, viewModel);
            ko.bindingHandlers.tooltip.init(element, valueAccessor, allBindingsAccessor, viewModel);
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            valueAccessor = getTooltipData(valueAccessor, viewModel);
            ko.bindingHandlers.tooltip.update(element, valueAccessor, allBindingsAccessor, viewModel);
        }
    };
    return ko.bindingHandlers.lTooltip;
});

